<template>
    <iframe v-if="gameUrl"
            :src="gameUrl"
            allow="autoplay; fullscreen"
            allowfullscreen="true"
            webkitallowfullscreen="true"
            mozallowfullscreen="true"></iframe>
</template>
<script>

export default {
    name: 'baas-frame',
    props: {
        session: {
            required: true
        }
    },
    computed: {
        gameUrl() {
            return this.session && this.session.sessionUrl;
        }
    }
};
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/common/baas/baas-frame.vue